/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setupprofiletitle2Inputs */

const en_setupprofiletitle2 = /** @type {(inputs: Setupprofiletitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are you setting up?`)
};

const de_setupprofiletitle2 = /** @type {(inputs: Setupprofiletitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was legst du an?`)
};

/**
* | output |
* | --- |
* | "What are you setting up?" |
*
* @param {Setupprofiletitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const setupprofiletitle2 = /** @type {((inputs?: Setupprofiletitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setupprofiletitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_setupprofiletitle2(inputs)
	return de_setupprofiletitle2(inputs)
});
export { setupprofiletitle2 as "setupProfileTitle" }